import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'self-ins-enrollment-confirmation',
    templateUrl: './enrollment-confirmation-page.component.html',
    styleUrls: ['./enrollment-confirmation-page.component.scss'],
    standalone: false
})

export class EnrollmentConfirmationPageComponent {
    constructor(private router: Router, private translate: TranslateService) {}

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}